module.exports = __webpack_public_path__ + "img/logo.5f4d2edf.jpg";